import React from "react";
import "./User.css";
import { useState } from "react";
import { Margin, X } from "@mui/icons-material";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import KeyIcon from '@mui/icons-material/Key';
import BookIcon from '@mui/icons-material/Book';
import GroupIcon from '@mui/icons-material/Group';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import CloseIcon from '@mui/icons-material/Close';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import { post, Token } from "../../../../Script/Session";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Userhistory from "./History/Userhistory";
import Groupediting from "./Group/Groupediting";
import copy from "copy-to-clipboard";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { Menu } from "@mui/material";
import { useRef } from "react";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import AlignHorizontalRightOutlinedIcon from '@mui/icons-material/AlignHorizontalRightOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import PeopleIcon from '@mui/icons-material/People';
import { Link } from "@mui/joy";
const User =  ({item,setfilterdata, filterdata, groups, update}) => {
    const [userPoints, setUserPoints] = useState(item.points);
    const navigate = useNavigate();

    let id = item.id;



    const [isOpen, setIsOpen] = useState(false);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  
    const handleClick = (e) => {
        setTimeout(() => {
            console.log(e.clientX + " " + e.clientY);
            setMousePos({ x: "70%", y: e.clientY });
            setIsOpen(true);
            console.log("set open true");
        },5);
      };
    
      useEffect(() => {
        const handleClickOutside = () => {
          if (isOpen) {
            console.log("set outside false");
            setIsOpen(false);
          }
        };
        if (isOpen) {
          document.addEventListener('click', handleClickOutside);
        }
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [isOpen]);
  

      function setpoints() {
        let points;

            const input = prompt("Neue Punkteanzahl:");
            points = parseFloat(input);
        if (isNaN(points)){
            return;
        }
        let body = {}
        body.token = Token.get();
        body.action = "setpoints";
        body.target = "" + id;
        body.value = "" + points;
        let response = post(body, "/usermanagement")
        if (response == null) {
            alert("Fehler in der NutzerVerwaltung");
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "NOPERMISSION"){
            alert("Fehlende Berechtigung");
            return;
        }
        if (response == "OK"){
            alert("Punkte Gesetzt");
            setUserPoints(points);
            updatepointsUser(points);
        }
      }
      function updatepointsUser(p){
        let f = filterdata.map(i =>
            i.id === item.id
              ? { ...item, points: p}
              : i
          );
          console.log(filterdata);
          console.log(f);
          setfilterdata(f);
      }

      function lockuser() {
        let body = {}
        body.token = Token.get();
        body.action = "lock";
        body.target = "" + id;
        let response = post(body, "/usermanagement")
        if (response == null) {
            alert("Fehler in der NutzerVerwaltung");
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "NOPERMISSION"){
            alert("Fehlende Berechtigung");
            return;
        }
        if (response == "OK"){
            alert("Nutzer Bearbeitet!");
        }
        updatedListlock();
      }
      function updatedListlock(){
      let f = filterdata.map(i =>
        i.id === item.id
          ? { ...item, locked: !item.locked }
          : i
      );
      setfilterdata(f);
     }
      function setpassword() {
        let body = {}
        body.token = Token.get();
        body.action = "setpassword";
        body.target = "" + id;
        let a = prompt("Neues Passwort Festlegen");
        if (!a){
            return;
        }
        body.password = a;
        let response = post(body, "/usermanagement")
        if (response == null) {
            alert("Fehler in der NutzerVerwaltung");
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "NOPERMISSION"){
            alert("Fehlende Berechtigung");
            return;
        }
        if (response == "OK"){
            alert("Passwort Gesetzt");
        }
      }
    function setmitglied() {
        let body = {}
        body.token = Token.get();
        body.action = "setmitglied";
        body.target = "" + id;
        let response = post(body, "/usermanagement")
        if (response == null) {
            alert("Fehler in der NutzerVerwaltung");
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "NOPERMISSION"){
            alert("Fehlende Berechtigung");
            return;
        }
        if (response == "OK"){
            alert("Status Gesetzt");
            update();
        }
      }

      function copyToClipboard(text) {
        //copy(text);

      }
      const [hoverLöschen, setHoverLöschen] = useState(false);
      const [hoverPunkte, setHoverPunkte] = useState(false);
      const [hoverPassword, setHoverPassword] = useState(false);
      const [hoverFunktionen, setHoverFunktionen] = useState(false);
      const [hoverHistorie, setHoverHistorie] = useState(false);
      const [groupmask, setgroupsmask] = useState(false);
      const [hoversetmitglied,sethoveristmitglied] = useState(false);
    return (
        <>
        {groupmask && (
            <Groupediting item={item} setfilterdata={setfilterdata} filterdata={filterdata} id={item.id} groups={groups} setmask={setgroupsmask}/>
        )}

        {isOpen && (
                <div
                style={{
                position: 'absolute',
                top: mousePos.y,
                left: mousePos.x,
                backgroundColor: 'white',
                width: '160px',
                boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                borderStyle: 'solid',
                borderColor: 'gray',
                borderWidth: '1px',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1000,
                }}
            >
                {/* Löschen */}
                <div
                onMouseEnter={() => setHoverLöschen(true)}
                onMouseLeave={() => setHoverLöschen(false)}
                onClick={() => lockuser()}
                style={{
                    height: '45px',
                    backgroundColor: hoverLöschen ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: !item.locked ? "red" : "gray",
                    cursor: 'pointer',
                }}
                >
                {!item.locked ? (
                    <>
                    <DeleteOutlineOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                    <p style={{ margin: 0 }}>Löschen</p>
                    </>

                ) : (
                    <>
                    <BackupOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                    <p style={{ margin: 0 }}>Wiederherstellen</p>
                    </>
                )}
                </div>

                {/* Punkte Setzen */}
                <div
                onMouseEnter={() => setHoverPunkte(true)}
                onMouseLeave={() => setHoverPunkte(false)}
                onClick={() => setpoints()}
                style={{
                    height: '45px',
                    backgroundColor: hoverPunkte ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                >
                <GpsFixedOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                <p style={{ margin: 0 }}>Punkte Setzen</p>
                </div>

                {/* Passwort Setzen */}
                <div
                onMouseEnter={() => setHoverPassword(true)}
                onMouseLeave={() => setHoverPassword(false)}
                onClick={() => setpassword()}
                style={{
                    height: '45px',
                    backgroundColor: hoverPassword ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                >
                <PasswordOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                <p style={{ margin: 0 }}>Password Setzen</p>
                </div>

                {/* Funktionen */}
                <div
                onMouseEnter={() => setHoverFunktionen(true)}
                onMouseLeave={() => setHoverFunktionen(false)}
                onClick={() => {setgroupsmask(true)
                    setHoverFunktionen(false);
                }}
                style={{
                    height: '45px',
                    backgroundColor: hoverFunktionen ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                >
                <AlignHorizontalRightOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                <p style={{ margin: 0 }}>Funktionen</p>
                </div>
                                <div
                onMouseEnter={() => sethoveristmitglied(true)}
                onMouseLeave={() => sethoveristmitglied(false)}
                onClick={() => setmitglied()}
                style={{
                    height: '45px',
                    backgroundColor: hoversetmitglied ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                >
                <PeopleIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                <p style={{ margin: 0 }}>Mitgliedstatus ändern</p>
                </div>

                {/* Historie */}
                <div
                onMouseEnter={() => setHoverHistorie(true)}
                onMouseLeave={() => setHoverHistorie(false)}
                style={{
                    height: '45px',
                    backgroundColor: hoverHistorie ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                onClick={() => navigate("/page-history/" + "verwaltung-nutzer-verwalten")}
                >
                <ScheduleOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                <p style={{ margin: 0 }}>Historie</p>
                </div>
            </div>
        )}
        <div id="asdasjdklasdkaklsdjlkajdlkasjdklöajsjldk"  style={{width: "100%", height: "90px", backgroundColor:"transparent", display: "flex", alignItems: "center",flexDirection: "row", justifyContent: "space-between"}}>
            <div style={{color: "black",marginLeft: "1.5%"}}>
                <p style={{fontWeight: "bold"}}><Link href={window.location.origin + "/my-profile/" + item.id}>{item.name}</Link></p>
                <p style={{marginTop: "-15px"}}>{item.email}</p>
                <p style={{marginTop: "-15px"}}>Erstellt am: {item.userentrydate}</p>
            </div>
            <div style={{color: "black",}}>
                <p style={{fontWeight: "bold"}}>Gelöscht: {item.locked ? "Ja" : "Nein"}</p>
                <p style={{marginTop: "-15px"}}>Punkte: {item.points}</p>
                <p style={{marginTop: "-15px"}}>Gruppen: {item.groups.length}</p>
            </div>
            <div style={{color: "black", width: "18%"}}>
                <p style={{fontWeight: "bold"}}>Regionalgruppe: {item.reggruppe}</p>
                <p style={{marginTop: "-15px"}}>Mitglied: {item.ismitglied ? "Ja" : "Nein"}</p>
                <p style={{marginTop: "-15px"}}>Letzter Login: {item.lastlogin}</p>
            </div>
            <div  style={{color: "black", marginRight: "15.5%"}} onClick={handleClick}>
                <TuneOutlinedIcon/>
            </div>
        </div>
        </>
    );


}
export default User; 